import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription, finalize } from 'rxjs';
import { SessionService } from 'src/app/Core/services/session.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  @Input() instruction!: string;
  @Input() index!: number;
  @Input() DocTypeId: any;
  @Input() AppId: any;
  @Input() completed: boolean = false;
  @Output() clicked: EventEmitter<void> = new EventEmitter();
  @Output() uploaded: EventEmitter<number> = new EventEmitter();

  selectedFile!: File;
  uploading = false;
  failed = false;
  maxSizeExceeded = false;
  speed = 0;
  rand = Math.random();
  uploadProgress: number = 0;
  uploadSub!: Subscription;
  lastChecked = 0;
  loading = false;
  errorMessage: string ='';
  constructor(private http: HttpClient, protected session: SessionService) { }

  chooseFile() {
    this.errorMessage = '';
    let uploader = document.getElementById(`fileUploader${this.rand}`);
    uploader?.click();
  }

  startUpload(ev: any) {
    this.selectedFile = ev.target.files[0];
    if (this.selectedFile) {
      if (this.fileSize > 1024) {
        this.maxSizeExceeded = true;
        return;
      }
      this.maxSizeExceeded = false;
      this.uploading = true;
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('DocTypeId', this.DocTypeId);
      formData.append('Name', this.selectedFile.name);
      let url =
        this.session.ApiUrl +
        `Application/UploadFile?AppId=${this.AppId}&DocTypeId=${this.DocTypeId}`;
      const upload$ = this.http
        .post(url, formData, {
          reportProgress: true,
          observe: 'events',
        })
        .pipe(
          finalize(() => {
            this.uploading = false;
            this.clearInput();
          })
        );

      this.loading = true;

      this.uploadSub = upload$.subscribe({
        next: (event) => {
          if (event.type == HttpEventType.UploadProgress) {
            this.uploadProgress = Math.round(
              100 * (event.loaded / (event?.total || 1))
            );
            this.calcSpeed(this.uploadProgress);
          }
        },
        error: (err: any) => {
          this.uploadProgress = 0;
          this.loading = false ;
          this.errorMessage =  this.errorMessage =  err?.error || 'An Error occurred while uploading the file';;
          this.uploaded.emit(0);
        },
        complete: () => {
          this.uploading = false;
          if (this.uploadProgress == 100) {
            this.completed = true;
            this.uploaded.emit(1);
          }
          this.loading = false;
          this.clearInput();
        },
      });
    }
  }

  cancelUpload() {
    this.uploadSub.unsubscribe();
    this.uploading = false;
    this.loading = false;
  }

  get fileSize() {
    return Math.ceil(this.selectedFile?.size / 1024) || 0;
  }

  get fileName() {
    let name = this.selectedFile?.name;
    if (!name) return '';
    let splittedName = name.split('.');
    let extension = splittedName[splittedName.length - 1];
    if (name.length > 25) {
      return name.slice(0, 22) + '...' + extension;
    }
    return this.selectedFile.name;
  }

  private calcSpeed(progress: number) {
    let diff = progress - this.lastChecked;
    this.lastChecked = progress;
    this.speed =
      Math.round((diff * this.fileSize) / 100) ||
      Math.round(this.speed + Math.random() * 10);
  }

  clearInput() {
    let el: any = document.getElementById(`fileUploader${this.rand}`);
    el.value = null;
  }

  deleteFile() {
    this.loading = true;
    let url = this.session.ApiUrl + 'Application/RemoveFile';
    let params = new HttpParams()
      .set('AppId', this.AppId)
      .set('DocTypeId', this.DocTypeId);
    this.http
      .get(url, {
        params,
      })
      .subscribe({
        next: (res: any) => {
          if (res.Data.Result) {
            this.completed = false;
            this.uploadProgress = 0;
            this.uploaded.emit(-1);
          }
          this.loading = false;
        },
        error: (err: any) => {
          this.loading = false;
        },
      });
  }
}
